import React from 'react'
import Typography from '@mui/material/Typography'
import { v4 as uuidv4 } from 'uuid'
import { useFormContext } from 'react-hook-form'
import WarrantSubPeriod from './AdminWarrantSubPeriod'
import Button from '@mui/material/Button'
import { WarrantListItem, WarrantSubscriptionPeriod } from '@finance-lab/utils/types'

type WarrantSubPeriodsProps = {
    warrant: WarrantListItem
}

export function WarrantSubPeriods({ warrant }: WarrantSubPeriodsProps) {
    const formMethods = useFormContext()

    const warrantSubPeriods = formMethods.watch('subscriptionPeriods') as Array<
        WarrantSubscriptionPeriod & { tempId: string }
    >

    const handleRemoveSubPeriod = (subPeriod: WarrantSubscriptionPeriod & { tempId: string }) => {
        if (warrantSubPeriods.length > 0) {
            const newSubPeriods = warrantSubPeriods.filter((sp) =>
                subPeriod.id ? sp.id !== subPeriod.id : sp.tempId !== subPeriod.tempId,
            )
            formMethods.setValue('subscriptionPeriods', newSubPeriods, { shouldDirty: true })
        }
    }
    const emptySubPeriod = (tempId: string, warrantId: string) => ({
        tempId,
        warrantId,
        subStartDate: null,
        subEndDate: null,
        warrantsRequired: null,
        commitments: null,
        guarantors: null,
        sharesSubscribed: null,
        sharesReceived: null,
        warrantSubPrice: null,
        vwapDiscount: null,
        vwapDays: null,
        vwapPeriodEnd: null,
        priceMinQuota: null,
        priceMin: null,
        noPriceMax: null,
        priceMax: null,
        isVwap: false,
    })
    const handleShowNewPeriodForm = () => {
        // setShowNewPeriodButton(!showNewPeriodButton)
        const newSubPeriods = [...warrantSubPeriods, emptySubPeriod(uuidv4(), warrant.id)]
        formMethods.setValue('subscriptionPeriods', newSubPeriods, { shouldDirty: true })
    }

    return (
        <>
            <Typography
                variant='h5'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                Teckningsperioder
            </Typography>
            {warrantSubPeriods.length === 0 && (
                <Typography variant='body1'>Inga befintliga teckningsperioder hittades</Typography>
            )}
            {warrantSubPeriods.length > 0 &&
                warrantSubPeriods.map((subPeriod, index) => (
                    <WarrantSubPeriod
                        subPeriod={subPeriod}
                        subPeriodIndex={index}
                        key={subPeriod.id || subPeriod.tempId}
                        handleRemoveSubPeriod={handleRemoveSubPeriod}
                    />
                ))}
            <Button variant='outlined' sx={{ my: 2 }} onClick={handleShowNewPeriodForm}>
                Ny teckningsperiod
            </Button>
        </>
    )
}
